module.exports = __webpack_public_path__ + "img/xiaomi.e8dd35ad.webp";